import type React from 'react';

export interface RendererProps {
  url: string;
  title: string;
}

export type Renderer = React.FC<RendererProps>;
